module.exports = __webpack_public_path__ + "static/img/11.35ae3aa.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/content-management/11.jpeg
// module id = Js0E
// module chunks = 3